import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./App.css";

// Components
import Navigation from "./components/Navigation";
import PatientForm from "./components/PatientForm";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import MyAppointments from "./components/MyAppointments";
import DiabetesCare from "./components/DiabetesCare";

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAdmin(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  // Wrapping everything in Router to ensure all router hooks work correctly
  return (
    <Router>
      <Routes>
        {/* Standalone diabetes care page - no navigation */}
        <Route path="/diabetes-care" element={<DiabetesCare />} />

        {/* Regular app routes with navigation */}
        <Route
          path="/*"
          element={
            <>
              <Navigation isAdmin={isAdmin} setIsAdmin={setIsAdmin} />
              <Routes>
                <Route path="/" element={<PatientForm />} />
                <Route path="/my-appointments" element={<MyAppointments />} />
                <Route
                  path="/admin-login"
                  element={
                    isAdmin ? (
                      <Navigate to="/admin" />
                    ) : (
                      <AdminLogin onLogin={() => setIsAdmin(true)} />
                    )
                  }
                />
                <Route
                  path="/admin"
                  element={
                    isAdmin ? (
                      <AdminDashboard />
                    ) : (
                      <Navigate to="/admin-login" />
                    )
                  }
                />
              </Routes>
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
